import React, { useEffect, useState } from 'react';
import { Box, Typography, Container, Grid, useTheme, useMediaQuery, Card, CardContent, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tabs, Tab } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
interface MakerInboxProps {
  onLogout: () => void;
}
interface RecordData {
  id: number;
  fullName: string;
  username: string;
  email: string;
  mobile: string;
  currency: string;
  branchCode: string;
  settlementAccount: string;
  designation: string;
  batchId: string;
  fileName: string;
  submittedAt: string;
  approvalStatus: 'pending' | 'completed' | 'rejected';
  checkerReason?: string;
  checkedAt?: string;
}
export default function MakerInbox({
  onLogout
}: MakerInboxProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [records, setRecords] = useState<RecordData[]>([]);
  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  useEffect(() => {
    // Load records from localStorage
    const storedRecords = JSON.parse(localStorage.getItem('makerInboxRecords') || '[]');
    setRecords(storedRecords);
    // Set up an interval to refresh records every 2 seconds to catch updates
    const interval = setInterval(() => {
      const updatedRecords = JSON.parse(localStorage.getItem('makerInboxRecords') || '[]');
      setRecords(updatedRecords);
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };
  const getFilteredRecords = () => {
    switch (activeTab) {
      case 0:
        return records.filter(r => r.approvalStatus === 'pending');
      case 1:
        return records.filter(r => r.approvalStatus === 'completed');
      case 2:
        return records.filter(r => r.approvalStatus === 'rejected');
      default:
        return records;
    }
  };
  const filteredRecords = getFilteredRecords();
  const renderRecordsTable = () => <TableContainer component={Paper} variant="outlined" data-id="element-3799" data-mp="2kmvobk77pt17">
      <Table data-id="element-3800" data-mp="2ft17qpmwlu6c">
        <TableHead data-id="element-3801" data-mp="2ftaqpt9j712j">
          <TableRow data-id="element-3802" data-mp="2frzk7lopbf7q">
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-3803" data-mp="2tlh457lautya">
              Full Name
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-3804" data-mp="2pj41is1unc5q">
              Username
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-3805" data-mp="2yktqzsc6810v">
              Email
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-3806" data-mp="1965nkglk5tez">
              Mobile
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-3807" data-mp="3fu5yg06no3v4">
              Branch Code
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-3808" data-mp="3ks7ianbwo77n">
              Batch
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-3809" data-mp="3b2o3bsrbcxi2">
              Status
            </TableCell>
            {activeTab !== 0 && <>
                <TableCell sx={{
              fontWeight: 600
            }} data-id="element-3810" data-mp="322rglwohi8pn">
                  Checker Reason
                </TableCell>
                <TableCell sx={{
              fontWeight: 600
            }} data-id="element-3811" data-mp="2s3s7ye3pyd2n">
                  Checked At
                </TableCell>
              </>}
          </TableRow>
        </TableHead>
        <TableBody data-id="element-3812" data-mp="qc5m0qyop8d1">
          {filteredRecords.map(record => <TableRow key={record.id} hover data-id="element-3813" data-mp="2mf1y8827878p">
              <TableCell data-id="element-3814" data-mp="2mdqwsew87bkr">{record.fullName}</TableCell>
              <TableCell data-id="element-3815" data-mp="2ift8deaa4tif">{record.username}</TableCell>
              <TableCell data-id="element-3816" data-mp="2dfewfl5k4zf4">{record.email}</TableCell>
              <TableCell data-id="element-3817" data-mp="2de3t1mg0xtoj">{record.mobile}</TableCell>
              <TableCell data-id="element-3818" data-mp="28gkhwvemhx0t">
                <Chip label={record.branchCode} size="small" sx={{
              backgroundColor: 'rgba(6, 182, 212, 0.1)',
              color: '#06B6D4',
              fontWeight: 600
            }} data-id="element-3819" data-mp="28h3rnou4df3r" />
              </TableCell>
              <TableCell data-id="element-3820" data-mp="1upfctdshkcj3">
                <Typography variant="body2" fontSize="0.85rem" data-id="element-3821" data-mp="1umjf9qkjvpv6">
                  {record.fileName}
                </Typography>
              </TableCell>
              <TableCell data-id="element-3822" data-mp="1kpoj3ebr21k2">
                <Chip label={record.approvalStatus === 'pending' ? 'Pending' : record.approvalStatus === 'completed' ? 'Completed' : 'Rejected'} size="small" sx={{
              backgroundColor: record.approvalStatus === 'pending' ? 'rgba(59, 130, 246, 0.1)' : record.approvalStatus === 'completed' ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)',
              color: record.approvalStatus === 'pending' ? '#3B82F6' : record.approvalStatus === 'completed' ? '#10B981' : '#EF4444',
              fontWeight: 600
            }} data-id="element-3823" data-mp="1kpy931wso8pr" />
              </TableCell>
              {activeTab !== 0 && <>
                  <TableCell data-id="element-3824" data-mp="9490vu4arjze">
                    <Typography variant="body2" fontSize="0.85rem" data-id="element-3825" data-mp="93h44fyyrg7j">
                      {record.checkerReason || '-'}
                    </Typography>
                  </TableCell>
                  <TableCell data-id="element-3826" data-mp="3s9ciscaxz0j8">
                    <Typography variant="body2" fontSize="0.85rem" data-id="element-3827" data-mp="aunwgmhhagze">
                      {record.checkedAt ? new Date(record.checkedAt).toLocaleDateString() : '-'}
                    </Typography>
                  </TableCell>
                </>}
            </TableRow>)}
          {filteredRecords.length === 0 && <TableRow data-id="element-3828" data-mp="3o9txhff7knfv">
              <TableCell colSpan={activeTab === 0 ? 7 : 9} align="center" sx={{
            py: 3
          }} data-id="element-3829" data-mp="3oad6u7qsm3ia">
                <Typography variant="body2" color="text.secondary" data-id="element-3830" data-mp="13jcozx4gxdzj">
                  No records found
                </Typography>
              </TableCell>
            </TableRow>}
        </TableBody>
      </Table>
    </TableContainer>;
  return <Box sx={{
    width: '100%',
    height: '100%',
    bgcolor: 'background.default'
  }} data-id="element-3831" data-mp="162ptzq0d7j8i">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} data-id="element-3832" data-mp="1b0remfdfvqm3" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="maker-inbox" data-id="element-3833" data-mp="x4xfup6dqhmp" />
      <Box component="main" sx={{
      flexGrow: 1,
      p: 3,
      width: {
        xs: '100%',
        sm: `calc(100% - ${240}px)`
      },
      ml: {
        xs: 0,
        sm: `${240}px`
      },
      mt: 8
    }} data-id="element-3834" data-mp="1170shh4sbs9k">
        <Container maxWidth="xl" data-id="element-3835" data-mp="1g046jej63nvj">
          <Grid container spacing={2} alignItems="center" sx={{
          mb: 3
        }} data-id="element-3836" data-mp="1k3aagfit52yu">
            <Grid item xs={12} data-id="element-3837" data-mp="27ra2rjvrp1fj">
              <Box sx={{
              display: 'flex',
              alignItems: 'center'
            }} data-id="element-3838" data-mp="2ckmp1ncz4w54">
                <Icon icon="lucide:inbox" width={24} height={24} color="#0EA5E9" data-id="element-3839" data-mp="1nurvkpc562pu" />
                <Typography variant="h5" component="h1" sx={{
                ml: 1.5,
                fontWeight: 600
              }} data-id="element-3840" data-mp="1e4p2yq8xmqs1">
                  Maker Inbox
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Card data-id="element-3841" data-mp="21r5bvv4xvy2q">
            <Box sx={{
            borderBottom: 1,
            borderColor: 'divider'
          }} data-id="element-3842" data-mp="21rdm1f9ogpa8">
              <Tabs value={activeTab} onChange={handleTabChange} sx={{
              px: 3
            }} data-id="element-3843" data-mp="1ru0nrprj9sja">
                <Tab label={<Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }} data-id="element-3845" data-mp="gekeutm524v9">
                      <Typography variant="body2" fontWeight={500} data-id="element-3846" data-mp="2wzz4m8digw1l">
                        Pending
                      </Typography>
                      <Chip label={records.filter(r => r.approvalStatus === 'pending').length} size="small" sx={{
                  height: 20,
                  fontSize: '0.7rem',
                  backgroundColor: 'rgba(59, 130, 246, 0.1)',
                  color: '#3B82F6'
                }} data-id="element-3847" data-mp="36seo5a4ghsol" />
                    </Box>} data-id="element-3844" data-mp="gfdp44kb3ci5" />
                <Tab label={<Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }} data-id="element-3849" data-mp="1vdhwrtksure2">
                      <Typography variant="body2" fontWeight={500} data-id="element-3850" data-mp="r8p9msnzazeh">
                        Completed
                      </Typography>
                      <Chip label={records.filter(r => r.approvalStatus === 'completed').length} size="small" sx={{
                  height: 20,
                  fontSize: '0.7rem',
                  backgroundColor: 'rgba(16, 185, 129, 0.1)',
                  color: '#10B981'
                }} data-id="element-3851" data-mp="107sspwn5besz" />
                    </Box>} data-id="element-3848" data-mp="1vcq0egjdopmq" />
                <Tab label={<Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }} data-id="element-3853" data-mp="1stvqk88cfqsb">
                      <Typography variant="body2" fontWeight={500} data-id="element-3854" data-mp="34db2clf260p4">
                        Rejected
                      </Typography>
                      <Chip label={records.filter(r => r.approvalStatus === 'rejected').length} size="small" sx={{
                  height: 20,
                  fontSize: '0.7rem',
                  backgroundColor: 'rgba(239, 68, 68, 0.1)',
                  color: '#EF4444'
                }} data-id="element-3855" data-mp="2zezps2xdpc37" />
                    </Box>} data-id="element-3852" data-mp="1svf43r2m7nqe" />
              </Tabs>
            </Box>
            <Box sx={{
            p: 3
          }} data-id="element-3856" data-mp="evlk25z2t3v3">
              {renderRecordsTable()}
            </Box>
          </Card>
        </Container>
      </Box>
    </Box>;
}